/**
 * PipelineDebugPanel — admin-only pipeline trace banner for SgpFlowScreen.
 * Extracted verbatim from SgpFlowScreen.jsx (god-file decomposition).
 * Parent gates with `_isAdminTop && responseMetadata &&`.
 */

import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

export default function PipelineDebugPanel({ responseMetadata, expanded, onToggle }) {
  return (
    <TouchableOpacity
      onPress={onToggle}
      activeOpacity={0.8}
      style={{
        marginTop: 6,
        backgroundColor: 'rgba(139,92,246,0.08)',
        borderWidth: 1,
        borderColor: 'rgba(139,92,246,0.25)',
        borderRadius: 8,
        paddingHorizontal: 10,
        paddingVertical: 7,
      }}
    >
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ color: '#8B5CF6', fontSize: 11, fontWeight: '700', letterSpacing: 0.5 }}>
          🧪 PIPELINE TRACE
        </Text>
        <Text style={{ color: '#6B7280', fontSize: 10 }}>
          {responseMetadata._metaSource || '—'} · {responseMetadata._durationMs != null ? `${responseMetadata._durationMs}ms` : ''} · {expanded ? '▲' : '▼'}
        </Text>
      </View>
      {expanded && (
        <View style={{ marginTop: 8, gap: 4 }}>
          {[
            ['Source', responseMetadata._metaSource],
            ['Cache', responseMetadata._cached != null ? (responseMetadata._cached ? `hit (${responseMetadata._cacheAgeSeconds != null ? Math.round(responseMetadata._cacheAgeSeconds / 60) + 'm' : '?'})` : 'miss') : null],
            ['Duration', responseMetadata._durationMs != null ? `${responseMetadata._durationMs}ms` : null],
            ['Sportsbook', responseMetadata._preferredSportsbook],
            ['League', responseMetadata._league],
            ['Team', responseMetadata._detectedTeam || responseMetadata._homeTeam],
            ['Market', responseMetadata._market],
            ['Bet Type', responseMetadata._queryClassification?.betType || responseMetadata._queryClassification?.type],
            ['Resolved Q', responseMetadata._resolvedQuery],
          ].filter(([, v]) => v != null && v !== '').map(([label, value]) => (
            <View key={label} style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ color: '#6B7280', fontSize: 10, flex: 1 }}>{label}</Text>
              <Text style={{ color: '#E5E7EB', fontSize: 10, fontWeight: '600', flex: 2, textAlign: 'right' }}>{String(value)}</Text>
            </View>
          ))}
          {responseMetadata._debug_path && (
            <View style={{ marginTop: 6, backgroundColor: '#0F172A', borderRadius: 6, padding: 8 }}>
              <Text style={{ color: '#86EFAC', fontSize: 10, fontFamily: 'monospace' }}>
                {JSON.stringify(responseMetadata._debug_path, null, 2)}
              </Text>
            </View>
          )}
          {!responseMetadata._debug_path && (
            <Text style={{ color: '#6B7280', fontSize: 10, marginTop: 4, fontStyle: 'italic' }}>
              No _debug_path — query ran through queryCachedSGPs (index.js path)
            </Text>
          )}
        </View>
      )}
    </TouchableOpacity>
  );
}
